/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginSignUpRouteImport } from './routes/login/sign-up'
import { Route as LoginForgotPasswordRouteImport } from './routes/login/forgot-password'
import { Route as AuthedSimulationRouteImport } from './routes/_authed/simulation'
import { Route as AuthedCompaniesIndexRouteImport } from './routes/_authed/companies/index'
import { Route as AuthedApplicationsIndexRouteImport } from './routes/_authed/applications/index'
import { Route as LoginAcceptInvitationInvitationIdRouteImport } from './routes/login/accept-invitation/$invitationId'
import { Route as AuthedCompaniesCompanySlugRouteImport } from './routes/_authed/companies/$companySlug'
import { Route as AuthedApplicationsApplicationIdRouteImport } from './routes/_authed/applications/$applicationId'
import { Route as AuthedCompaniesCompanySlugUsersRouteImport } from './routes/_authed/companies/$companySlug/users'
import { Route as AuthedCompaniesCompanySlugSettingsRouteImport } from './routes/_authed/companies/$companySlug/settings'
import { Route as AuthedCompaniesCompanySlugPersonsRouteImport } from './routes/_authed/companies/$companySlug/persons'
import { Route as AuthedApplicationsApplicationIdReceiptsRouteImport } from './routes/_authed/applications/$applicationId/receipts'
import { Route as AuthedApplicationsApplicationIdProfileRouteImport } from './routes/_authed/applications/$applicationId/profile'
import { Route as AuthedApplicationsApplicationIdDataConfirmationRouteImport } from './routes/_authed/applications/$applicationId/data-confirmation'
import { Route as AuthedApplicationsApplicationIdApplicationInfoRouteImport } from './routes/_authed/applications/$applicationId/application-info'
import { Route as AuthedCompaniesCompanySlugFacilitiesIndexRouteImport } from './routes/_authed/companies/$companySlug/facilities/index'
import { Route as AuthedCompaniesCompanySlugApplicationsIndexRouteImport } from './routes/_authed/companies/$companySlug/applications/index'
import { Route as AuthedApplicationsApplicationIdGuarantorsIndexRouteImport } from './routes/_authed/applications/$applicationId/guarantors/index'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/settings'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId/receipts'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId/profile'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId/data-confirmation'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId/application-info'
import { Route as AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport } from './routes/_authed/applications/$applicationId/guarantors/$guarantorId/profile'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/index'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId/guarantors/index'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info'
import { Route as AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport } from './routes/_authed/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/index'
import { Route as AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport } from './routes/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSignUpRoute = LoginSignUpRouteImport.update({
  id: '/login/sign-up',
  path: '/login/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginForgotPasswordRoute = LoginForgotPasswordRouteImport.update({
  id: '/login/forgot-password',
  path: '/login/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSimulationRoute = AuthedSimulationRouteImport.update({
  id: '/simulation',
  path: '/simulation',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompaniesIndexRoute = AuthedCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedApplicationsIndexRoute = AuthedApplicationsIndexRouteImport.update({
  id: '/applications/',
  path: '/applications/',
  getParentRoute: () => AuthedRoute,
} as any)
const LoginAcceptInvitationInvitationIdRoute =
  LoginAcceptInvitationInvitationIdRouteImport.update({
    id: '/login/accept-invitation/$invitationId',
    path: '/login/accept-invitation/$invitationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedCompaniesCompanySlugRoute =
  AuthedCompaniesCompanySlugRouteImport.update({
    id: '/companies/$companySlug',
    path: '/companies/$companySlug',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedApplicationsApplicationIdRoute =
  AuthedApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCompaniesCompanySlugUsersRoute =
  AuthedCompaniesCompanySlugUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedCompaniesCompanySlugSettingsRoute =
  AuthedCompaniesCompanySlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedCompaniesCompanySlugPersonsRoute =
  AuthedCompaniesCompanySlugPersonsRouteImport.update({
    id: '/persons',
    path: '/persons',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedApplicationsApplicationIdReceiptsRoute =
  AuthedApplicationsApplicationIdReceiptsRouteImport.update({
    id: '/receipts',
    path: '/receipts',
    getParentRoute: () => AuthedApplicationsApplicationIdRoute,
  } as any)
const AuthedApplicationsApplicationIdProfileRoute =
  AuthedApplicationsApplicationIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthedApplicationsApplicationIdRoute,
  } as any)
const AuthedApplicationsApplicationIdDataConfirmationRoute =
  AuthedApplicationsApplicationIdDataConfirmationRouteImport.update({
    id: '/data-confirmation',
    path: '/data-confirmation',
    getParentRoute: () => AuthedApplicationsApplicationIdRoute,
  } as any)
const AuthedApplicationsApplicationIdApplicationInfoRoute =
  AuthedApplicationsApplicationIdApplicationInfoRouteImport.update({
    id: '/application-info',
    path: '/application-info',
    getParentRoute: () => AuthedApplicationsApplicationIdRoute,
  } as any)
const AuthedCompaniesCompanySlugFacilitiesIndexRoute =
  AuthedCompaniesCompanySlugFacilitiesIndexRouteImport.update({
    id: '/facilities/',
    path: '/facilities/',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedCompaniesCompanySlugApplicationsIndexRoute =
  AuthedCompaniesCompanySlugApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedApplicationsApplicationIdGuarantorsIndexRoute =
  AuthedApplicationsApplicationIdGuarantorsIndexRouteImport.update({
    id: '/guarantors/',
    path: '/guarantors/',
    getParentRoute: () => AuthedApplicationsApplicationIdRoute,
  } as any)
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteImport.update({
    id: '/facilities/$facilitySlug',
    path: '/facilities/$facilitySlug',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedCompaniesCompanySlugApplicationsApplicationIdRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdRouteImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => AuthedCompaniesCompanySlugRoute,
  } as any)
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute,
  } as any)
const AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRouteImport.update(
    {
      id: '/receipts',
      path: '/receipts',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () =>
      AuthedCompaniesCompanySlugApplicationsApplicationIdRoute,
  } as any)
const AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRouteImport.update(
    {
      id: '/data-confirmation',
      path: '/data-confirmation',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRouteImport.update(
    {
      id: '/application-info',
      path: '/application-info',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute =
  AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport.update(
    {
      id: '/guarantors/$guarantorId/profile',
      path: '/guarantors/$guarantorId/profile',
      getParentRoute: () => AuthedApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRouteImport.update(
    {
      id: '/applications/',
      path: '/applications/',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRouteImport.update(
    {
      id: '/guarantors/',
      path: '/guarantors/',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteImport.update(
    {
      id: '/applications/$applicationId',
      path: '/applications/$applicationId',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRouteImport.update(
    {
      id: '/receipts',
      path: '/receipts',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRouteImport.update(
    {
      id: '/profile',
      path: '/profile',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRouteImport.update(
    {
      id: '/data-confirmation',
      path: '/data-confirmation',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRouteImport.update(
    {
      id: '/application-info',
      path: '/application-info',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute =
  AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport.update(
    {
      id: '/guarantors/$guarantorId/profile',
      path: '/guarantors/$guarantorId/profile',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRouteImport.update(
    {
      id: '/guarantors/',
      path: '/guarantors/',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute,
    } as any,
  )
const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport.update(
    {
      id: '/guarantors/$guarantorId/profile',
      path: '/guarantors/$guarantorId/profile',
      getParentRoute: () =>
        AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/simulation': typeof AuthedSimulationRoute
  '/login/forgot-password': typeof LoginForgotPasswordRoute
  '/login/sign-up': typeof LoginSignUpRoute
  '/login/': typeof LoginIndexRoute
  '/applications/$applicationId': typeof AuthedApplicationsApplicationIdRouteWithChildren
  '/companies/$companySlug': typeof AuthedCompaniesCompanySlugRouteWithChildren
  '/login/accept-invitation/$invitationId': typeof LoginAcceptInvitationInvitationIdRoute
  '/applications/': typeof AuthedApplicationsIndexRoute
  '/companies/': typeof AuthedCompaniesIndexRoute
  '/applications/$applicationId/application-info': typeof AuthedApplicationsApplicationIdApplicationInfoRoute
  '/applications/$applicationId/data-confirmation': typeof AuthedApplicationsApplicationIdDataConfirmationRoute
  '/applications/$applicationId/profile': typeof AuthedApplicationsApplicationIdProfileRoute
  '/applications/$applicationId/receipts': typeof AuthedApplicationsApplicationIdReceiptsRoute
  '/companies/$companySlug/persons': typeof AuthedCompaniesCompanySlugPersonsRoute
  '/companies/$companySlug/settings': typeof AuthedCompaniesCompanySlugSettingsRoute
  '/companies/$companySlug/users': typeof AuthedCompaniesCompanySlugUsersRoute
  '/companies/$companySlug/applications/$applicationId': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRouteWithChildren
  '/companies/$companySlug/facilities/$facilitySlug': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteWithChildren
  '/applications/$applicationId/guarantors/': typeof AuthedApplicationsApplicationIdGuarantorsIndexRoute
  '/companies/$companySlug/applications/': typeof AuthedCompaniesCompanySlugApplicationsIndexRoute
  '/companies/$companySlug/facilities/': typeof AuthedCompaniesCompanySlugFacilitiesIndexRoute
  '/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
  '/companies/$companySlug/applications/$applicationId/application-info': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute
  '/companies/$companySlug/applications/$applicationId/data-confirmation': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute
  '/companies/$companySlug/applications/$applicationId/profile': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute
  '/companies/$companySlug/applications/$applicationId/receipts': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute
  '/companies/$companySlug/facilities/$facilitySlug/settings': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteWithChildren
  '/companies/$companySlug/applications/$applicationId/guarantors/': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute
  '/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/simulation': typeof AuthedSimulationRoute
  '/login/forgot-password': typeof LoginForgotPasswordRoute
  '/login/sign-up': typeof LoginSignUpRoute
  '/login': typeof LoginIndexRoute
  '/applications/$applicationId': typeof AuthedApplicationsApplicationIdRouteWithChildren
  '/companies/$companySlug': typeof AuthedCompaniesCompanySlugRouteWithChildren
  '/login/accept-invitation/$invitationId': typeof LoginAcceptInvitationInvitationIdRoute
  '/applications': typeof AuthedApplicationsIndexRoute
  '/companies': typeof AuthedCompaniesIndexRoute
  '/applications/$applicationId/application-info': typeof AuthedApplicationsApplicationIdApplicationInfoRoute
  '/applications/$applicationId/data-confirmation': typeof AuthedApplicationsApplicationIdDataConfirmationRoute
  '/applications/$applicationId/profile': typeof AuthedApplicationsApplicationIdProfileRoute
  '/applications/$applicationId/receipts': typeof AuthedApplicationsApplicationIdReceiptsRoute
  '/companies/$companySlug/persons': typeof AuthedCompaniesCompanySlugPersonsRoute
  '/companies/$companySlug/settings': typeof AuthedCompaniesCompanySlugSettingsRoute
  '/companies/$companySlug/users': typeof AuthedCompaniesCompanySlugUsersRoute
  '/companies/$companySlug/applications/$applicationId': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRouteWithChildren
  '/companies/$companySlug/facilities/$facilitySlug': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteWithChildren
  '/applications/$applicationId/guarantors': typeof AuthedApplicationsApplicationIdGuarantorsIndexRoute
  '/companies/$companySlug/applications': typeof AuthedCompaniesCompanySlugApplicationsIndexRoute
  '/companies/$companySlug/facilities': typeof AuthedCompaniesCompanySlugFacilitiesIndexRoute
  '/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
  '/companies/$companySlug/applications/$applicationId/application-info': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute
  '/companies/$companySlug/applications/$applicationId/data-confirmation': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute
  '/companies/$companySlug/applications/$applicationId/profile': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute
  '/companies/$companySlug/applications/$applicationId/receipts': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute
  '/companies/$companySlug/facilities/$facilitySlug/settings': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteWithChildren
  '/companies/$companySlug/applications/$applicationId/guarantors': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute
  '/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute
  '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/_authed/simulation': typeof AuthedSimulationRoute
  '/login/forgot-password': typeof LoginForgotPasswordRoute
  '/login/sign-up': typeof LoginSignUpRoute
  '/login/': typeof LoginIndexRoute
  '/_authed/applications/$applicationId': typeof AuthedApplicationsApplicationIdRouteWithChildren
  '/_authed/companies/$companySlug': typeof AuthedCompaniesCompanySlugRouteWithChildren
  '/login/accept-invitation/$invitationId': typeof LoginAcceptInvitationInvitationIdRoute
  '/_authed/applications/': typeof AuthedApplicationsIndexRoute
  '/_authed/companies/': typeof AuthedCompaniesIndexRoute
  '/_authed/applications/$applicationId/application-info': typeof AuthedApplicationsApplicationIdApplicationInfoRoute
  '/_authed/applications/$applicationId/data-confirmation': typeof AuthedApplicationsApplicationIdDataConfirmationRoute
  '/_authed/applications/$applicationId/profile': typeof AuthedApplicationsApplicationIdProfileRoute
  '/_authed/applications/$applicationId/receipts': typeof AuthedApplicationsApplicationIdReceiptsRoute
  '/_authed/companies/$companySlug/persons': typeof AuthedCompaniesCompanySlugPersonsRoute
  '/_authed/companies/$companySlug/settings': typeof AuthedCompaniesCompanySlugSettingsRoute
  '/_authed/companies/$companySlug/users': typeof AuthedCompaniesCompanySlugUsersRoute
  '/_authed/companies/$companySlug/applications/$applicationId': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRouteWithChildren
  '/_authed/companies/$companySlug/facilities/$facilitySlug': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteWithChildren
  '/_authed/applications/$applicationId/guarantors/': typeof AuthedApplicationsApplicationIdGuarantorsIndexRoute
  '/_authed/companies/$companySlug/applications/': typeof AuthedCompaniesCompanySlugApplicationsIndexRoute
  '/_authed/companies/$companySlug/facilities/': typeof AuthedCompaniesCompanySlugFacilitiesIndexRoute
  '/_authed/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
  '/_authed/companies/$companySlug/applications/$applicationId/application-info': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute
  '/_authed/companies/$companySlug/applications/$applicationId/data-confirmation': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute
  '/_authed/companies/$companySlug/applications/$applicationId/profile': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute
  '/_authed/companies/$companySlug/applications/$applicationId/receipts': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/settings': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteWithChildren
  '/_authed/companies/$companySlug/applications/$applicationId/guarantors/': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute
  '/_authed/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile': typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/simulation'
    | '/login/forgot-password'
    | '/login/sign-up'
    | '/login/'
    | '/applications/$applicationId'
    | '/companies/$companySlug'
    | '/login/accept-invitation/$invitationId'
    | '/applications/'
    | '/companies/'
    | '/applications/$applicationId/application-info'
    | '/applications/$applicationId/data-confirmation'
    | '/applications/$applicationId/profile'
    | '/applications/$applicationId/receipts'
    | '/companies/$companySlug/persons'
    | '/companies/$companySlug/settings'
    | '/companies/$companySlug/users'
    | '/companies/$companySlug/applications/$applicationId'
    | '/companies/$companySlug/facilities/$facilitySlug'
    | '/applications/$applicationId/guarantors/'
    | '/companies/$companySlug/applications/'
    | '/companies/$companySlug/facilities/'
    | '/applications/$applicationId/guarantors/$guarantorId/profile'
    | '/companies/$companySlug/applications/$applicationId/application-info'
    | '/companies/$companySlug/applications/$applicationId/data-confirmation'
    | '/companies/$companySlug/applications/$applicationId/profile'
    | '/companies/$companySlug/applications/$applicationId/receipts'
    | '/companies/$companySlug/facilities/$facilitySlug/settings'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId'
    | '/companies/$companySlug/applications/$applicationId/guarantors/'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/'
    | '/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/simulation'
    | '/login/forgot-password'
    | '/login/sign-up'
    | '/login'
    | '/applications/$applicationId'
    | '/companies/$companySlug'
    | '/login/accept-invitation/$invitationId'
    | '/applications'
    | '/companies'
    | '/applications/$applicationId/application-info'
    | '/applications/$applicationId/data-confirmation'
    | '/applications/$applicationId/profile'
    | '/applications/$applicationId/receipts'
    | '/companies/$companySlug/persons'
    | '/companies/$companySlug/settings'
    | '/companies/$companySlug/users'
    | '/companies/$companySlug/applications/$applicationId'
    | '/companies/$companySlug/facilities/$facilitySlug'
    | '/applications/$applicationId/guarantors'
    | '/companies/$companySlug/applications'
    | '/companies/$companySlug/facilities'
    | '/applications/$applicationId/guarantors/$guarantorId/profile'
    | '/companies/$companySlug/applications/$applicationId/application-info'
    | '/companies/$companySlug/applications/$applicationId/data-confirmation'
    | '/companies/$companySlug/applications/$applicationId/profile'
    | '/companies/$companySlug/applications/$applicationId/receipts'
    | '/companies/$companySlug/facilities/$facilitySlug/settings'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId'
    | '/companies/$companySlug/applications/$applicationId/guarantors'
    | '/companies/$companySlug/facilities/$facilitySlug/applications'
    | '/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors'
    | '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/_authed/simulation'
    | '/login/forgot-password'
    | '/login/sign-up'
    | '/login/'
    | '/_authed/applications/$applicationId'
    | '/_authed/companies/$companySlug'
    | '/login/accept-invitation/$invitationId'
    | '/_authed/applications/'
    | '/_authed/companies/'
    | '/_authed/applications/$applicationId/application-info'
    | '/_authed/applications/$applicationId/data-confirmation'
    | '/_authed/applications/$applicationId/profile'
    | '/_authed/applications/$applicationId/receipts'
    | '/_authed/companies/$companySlug/persons'
    | '/_authed/companies/$companySlug/settings'
    | '/_authed/companies/$companySlug/users'
    | '/_authed/companies/$companySlug/applications/$applicationId'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug'
    | '/_authed/applications/$applicationId/guarantors/'
    | '/_authed/companies/$companySlug/applications/'
    | '/_authed/companies/$companySlug/facilities/'
    | '/_authed/applications/$applicationId/guarantors/$guarantorId/profile'
    | '/_authed/companies/$companySlug/applications/$applicationId/application-info'
    | '/_authed/companies/$companySlug/applications/$applicationId/data-confirmation'
    | '/_authed/companies/$companySlug/applications/$applicationId/profile'
    | '/_authed/companies/$companySlug/applications/$applicationId/receipts'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/settings'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId'
    | '/_authed/companies/$companySlug/applications/$applicationId/guarantors/'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/'
    | '/_authed/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/'
    | '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginForgotPasswordRoute: typeof LoginForgotPasswordRoute
  LoginSignUpRoute: typeof LoginSignUpRoute
  LoginIndexRoute: typeof LoginIndexRoute
  LoginAcceptInvitationInvitationIdRoute: typeof LoginAcceptInvitationInvitationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/sign-up': {
      id: '/login/sign-up'
      path: '/login/sign-up'
      fullPath: '/login/sign-up'
      preLoaderRoute: typeof LoginSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/forgot-password': {
      id: '/login/forgot-password'
      path: '/login/forgot-password'
      fullPath: '/login/forgot-password'
      preLoaderRoute: typeof LoginForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/simulation': {
      id: '/_authed/simulation'
      path: '/simulation'
      fullPath: '/simulation'
      preLoaderRoute: typeof AuthedSimulationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/companies/': {
      id: '/_authed/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthedCompaniesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/applications/': {
      id: '/_authed/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof AuthedApplicationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/login/accept-invitation/$invitationId': {
      id: '/login/accept-invitation/$invitationId'
      path: '/login/accept-invitation/$invitationId'
      fullPath: '/login/accept-invitation/$invitationId'
      preLoaderRoute: typeof LoginAcceptInvitationInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/companies/$companySlug': {
      id: '/_authed/companies/$companySlug'
      path: '/companies/$companySlug'
      fullPath: '/companies/$companySlug'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/applications/$applicationId': {
      id: '/_authed/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/applications/$applicationId'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/companies/$companySlug/users': {
      id: '/_authed/companies/$companySlug/users'
      path: '/users'
      fullPath: '/companies/$companySlug/users'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugUsersRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/companies/$companySlug/settings': {
      id: '/_authed/companies/$companySlug/settings'
      path: '/settings'
      fullPath: '/companies/$companySlug/settings'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugSettingsRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/companies/$companySlug/persons': {
      id: '/_authed/companies/$companySlug/persons'
      path: '/persons'
      fullPath: '/companies/$companySlug/persons'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugPersonsRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/applications/$applicationId/receipts': {
      id: '/_authed/applications/$applicationId/receipts'
      path: '/receipts'
      fullPath: '/applications/$applicationId/receipts'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdReceiptsRouteImport
      parentRoute: typeof AuthedApplicationsApplicationIdRoute
    }
    '/_authed/applications/$applicationId/profile': {
      id: '/_authed/applications/$applicationId/profile'
      path: '/profile'
      fullPath: '/applications/$applicationId/profile'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdProfileRouteImport
      parentRoute: typeof AuthedApplicationsApplicationIdRoute
    }
    '/_authed/applications/$applicationId/data-confirmation': {
      id: '/_authed/applications/$applicationId/data-confirmation'
      path: '/data-confirmation'
      fullPath: '/applications/$applicationId/data-confirmation'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdDataConfirmationRouteImport
      parentRoute: typeof AuthedApplicationsApplicationIdRoute
    }
    '/_authed/applications/$applicationId/application-info': {
      id: '/_authed/applications/$applicationId/application-info'
      path: '/application-info'
      fullPath: '/applications/$applicationId/application-info'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdApplicationInfoRouteImport
      parentRoute: typeof AuthedApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/': {
      id: '/_authed/companies/$companySlug/facilities/'
      path: '/facilities'
      fullPath: '/companies/$companySlug/facilities/'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesIndexRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/companies/$companySlug/applications/': {
      id: '/_authed/companies/$companySlug/applications/'
      path: '/applications'
      fullPath: '/companies/$companySlug/applications/'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsIndexRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/applications/$applicationId/guarantors/': {
      id: '/_authed/applications/$applicationId/guarantors/'
      path: '/guarantors'
      fullPath: '/applications/$applicationId/guarantors/'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdGuarantorsIndexRouteImport
      parentRoute: typeof AuthedApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug'
      path: '/facilities/$facilitySlug'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId': {
      id: '/_authed/companies/$companySlug/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/companies/$companySlug/applications/$applicationId'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/settings': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/settings'
      path: '/settings'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/settings'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId/receipts': {
      id: '/_authed/companies/$companySlug/applications/$applicationId/receipts'
      path: '/receipts'
      fullPath: '/companies/$companySlug/applications/$applicationId/receipts'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId/profile': {
      id: '/_authed/companies/$companySlug/applications/$applicationId/profile'
      path: '/profile'
      fullPath: '/companies/$companySlug/applications/$applicationId/profile'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId/data-confirmation': {
      id: '/_authed/companies/$companySlug/applications/$applicationId/data-confirmation'
      path: '/data-confirmation'
      fullPath: '/companies/$companySlug/applications/$applicationId/data-confirmation'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId/application-info': {
      id: '/_authed/companies/$companySlug/applications/$applicationId/application-info'
      path: '/application-info'
      fullPath: '/companies/$companySlug/applications/$applicationId/application-info'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRoute
    }
    '/_authed/applications/$applicationId/guarantors/$guarantorId/profile': {
      id: '/_authed/applications/$applicationId/guarantors/$guarantorId/profile'
      path: '/guarantors/$guarantorId/profile'
      fullPath: '/applications/$applicationId/guarantors/$guarantorId/profile'
      preLoaderRoute: typeof AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport
      parentRoute: typeof AuthedApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/'
      path: '/applications'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId/guarantors/': {
      id: '/_authed/companies/$companySlug/applications/$applicationId/guarantors/'
      path: '/guarantors'
      fullPath: '/companies/$companySlug/applications/$applicationId/guarantors/'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts'
      path: '/receipts'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/receipts'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile'
      path: '/profile'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation'
      path: '/data-confirmation'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/data-confirmation'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info'
      path: '/application-info'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/application-info'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile': {
      id: '/_authed/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile'
      path: '/guarantors/$guarantorId/profile'
      fullPath: '/companies/$companySlug/applications/$applicationId/guarantors/$guarantorId/profile'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/'
      path: '/guarantors'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute
    }
    '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile': {
      id: '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile'
      path: '/guarantors/$guarantorId/profile'
      fullPath: '/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/guarantors/$guarantorId/profile'
      preLoaderRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRouteImport
      parentRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute
    }
  }
}

interface AuthedApplicationsApplicationIdRouteChildren {
  AuthedApplicationsApplicationIdApplicationInfoRoute: typeof AuthedApplicationsApplicationIdApplicationInfoRoute
  AuthedApplicationsApplicationIdDataConfirmationRoute: typeof AuthedApplicationsApplicationIdDataConfirmationRoute
  AuthedApplicationsApplicationIdProfileRoute: typeof AuthedApplicationsApplicationIdProfileRoute
  AuthedApplicationsApplicationIdReceiptsRoute: typeof AuthedApplicationsApplicationIdReceiptsRoute
  AuthedApplicationsApplicationIdGuarantorsIndexRoute: typeof AuthedApplicationsApplicationIdGuarantorsIndexRoute
  AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute: typeof AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
}

const AuthedApplicationsApplicationIdRouteChildren: AuthedApplicationsApplicationIdRouteChildren =
  {
    AuthedApplicationsApplicationIdApplicationInfoRoute:
      AuthedApplicationsApplicationIdApplicationInfoRoute,
    AuthedApplicationsApplicationIdDataConfirmationRoute:
      AuthedApplicationsApplicationIdDataConfirmationRoute,
    AuthedApplicationsApplicationIdProfileRoute:
      AuthedApplicationsApplicationIdProfileRoute,
    AuthedApplicationsApplicationIdReceiptsRoute:
      AuthedApplicationsApplicationIdReceiptsRoute,
    AuthedApplicationsApplicationIdGuarantorsIndexRoute:
      AuthedApplicationsApplicationIdGuarantorsIndexRoute,
    AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute:
      AuthedApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute,
  }

const AuthedApplicationsApplicationIdRouteWithChildren =
  AuthedApplicationsApplicationIdRoute._addFileChildren(
    AuthedApplicationsApplicationIdRouteChildren,
  )

interface AuthedCompaniesCompanySlugApplicationsApplicationIdRouteChildren {
  AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute
  AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute
  AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute
  AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute
  AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute
  AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
}

const AuthedCompaniesCompanySlugApplicationsApplicationIdRouteChildren: AuthedCompaniesCompanySlugApplicationsApplicationIdRouteChildren =
  {
    AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdApplicationInfoRoute,
    AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdDataConfirmationRoute,
    AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdProfileRoute,
    AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdReceiptsRoute,
    AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsIndexRoute,
    AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute,
  }

const AuthedCompaniesCompanySlugApplicationsApplicationIdRouteWithChildren =
  AuthedCompaniesCompanySlugApplicationsApplicationIdRoute._addFileChildren(
    AuthedCompaniesCompanySlugApplicationsApplicationIdRouteChildren,
  )

interface AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteChildren {
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute
}

const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteChildren: AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteChildren =
  {
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdApplicationInfoRoute,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdDataConfirmationRoute,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdProfileRoute,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdReceiptsRoute,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsIndexRoute,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdGuarantorsGuarantorIdProfileRoute,
  }

const AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteWithChildren =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute._addFileChildren(
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteChildren,
  )

interface AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteChildren {
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteWithChildren
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute
}

const AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteChildren: AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteChildren =
  {
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugSettingsRoute,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsApplicationIdRouteWithChildren,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugApplicationsIndexRoute,
  }

const AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteWithChildren =
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute._addFileChildren(
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteChildren,
  )

interface AuthedCompaniesCompanySlugRouteChildren {
  AuthedCompaniesCompanySlugPersonsRoute: typeof AuthedCompaniesCompanySlugPersonsRoute
  AuthedCompaniesCompanySlugSettingsRoute: typeof AuthedCompaniesCompanySlugSettingsRoute
  AuthedCompaniesCompanySlugUsersRoute: typeof AuthedCompaniesCompanySlugUsersRoute
  AuthedCompaniesCompanySlugApplicationsApplicationIdRoute: typeof AuthedCompaniesCompanySlugApplicationsApplicationIdRouteWithChildren
  AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute: typeof AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteWithChildren
  AuthedCompaniesCompanySlugApplicationsIndexRoute: typeof AuthedCompaniesCompanySlugApplicationsIndexRoute
  AuthedCompaniesCompanySlugFacilitiesIndexRoute: typeof AuthedCompaniesCompanySlugFacilitiesIndexRoute
}

const AuthedCompaniesCompanySlugRouteChildren: AuthedCompaniesCompanySlugRouteChildren =
  {
    AuthedCompaniesCompanySlugPersonsRoute:
      AuthedCompaniesCompanySlugPersonsRoute,
    AuthedCompaniesCompanySlugSettingsRoute:
      AuthedCompaniesCompanySlugSettingsRoute,
    AuthedCompaniesCompanySlugUsersRoute: AuthedCompaniesCompanySlugUsersRoute,
    AuthedCompaniesCompanySlugApplicationsApplicationIdRoute:
      AuthedCompaniesCompanySlugApplicationsApplicationIdRouteWithChildren,
    AuthedCompaniesCompanySlugFacilitiesFacilitySlugRoute:
      AuthedCompaniesCompanySlugFacilitiesFacilitySlugRouteWithChildren,
    AuthedCompaniesCompanySlugApplicationsIndexRoute:
      AuthedCompaniesCompanySlugApplicationsIndexRoute,
    AuthedCompaniesCompanySlugFacilitiesIndexRoute:
      AuthedCompaniesCompanySlugFacilitiesIndexRoute,
  }

const AuthedCompaniesCompanySlugRouteWithChildren =
  AuthedCompaniesCompanySlugRoute._addFileChildren(
    AuthedCompaniesCompanySlugRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedSimulationRoute: typeof AuthedSimulationRoute
  AuthedApplicationsApplicationIdRoute: typeof AuthedApplicationsApplicationIdRouteWithChildren
  AuthedCompaniesCompanySlugRoute: typeof AuthedCompaniesCompanySlugRouteWithChildren
  AuthedApplicationsIndexRoute: typeof AuthedApplicationsIndexRoute
  AuthedCompaniesIndexRoute: typeof AuthedCompaniesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSimulationRoute: AuthedSimulationRoute,
  AuthedApplicationsApplicationIdRoute:
    AuthedApplicationsApplicationIdRouteWithChildren,
  AuthedCompaniesCompanySlugRoute: AuthedCompaniesCompanySlugRouteWithChildren,
  AuthedApplicationsIndexRoute: AuthedApplicationsIndexRoute,
  AuthedCompaniesIndexRoute: AuthedCompaniesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginForgotPasswordRoute: LoginForgotPasswordRoute,
  LoginSignUpRoute: LoginSignUpRoute,
  LoginIndexRoute: LoginIndexRoute,
  LoginAcceptInvitationInvitationIdRoute:
    LoginAcceptInvitationInvitationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
